import { render, staticRenderFns } from "./DocIcon.vue?vue&type=template&id=6b1a5e2a&functional=true&lang=pug&"
import script from "./DocIcon.vue?vue&type=script&lang=ts&"
export * from "./DocIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DocIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports